import { IPreferredStatusMapping } from 'components/ProviderData/IpaAdministration/atoms/Models';

const dateFields: (keyof IPreferredStatusMapping)[] = ['startDate', 'endDate', 'createdAt', 'lastUpdatedAt'];

export type DropDownItem = { id: number; desc: string };

export const moveToBottom = (data: DropDownItem[], predicate: (item: DropDownItem) => boolean): DropDownItem[] => {
    const matchingItems = data.filter((item) => predicate(item));
    const nonMatchingItems = data.filter((item) => !predicate(item));
    return [...nonMatchingItems, ...matchingItems];
};

export const normalizePreferredStatusDates = (data: IPreferredStatusMapping[]): IPreferredStatusMapping[] =>
    data.map((row) => {
        const result = { ...row } as Record<string, unknown>;
        dateFields.forEach((field) => {
            if (result[field]) {
                const date = new Date(result[field] as string | Date);
                result[field] = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            }
        });
        return result as unknown as IPreferredStatusMapping;
    });
